export const SKILL_213_CODE = '213';
export const TEAME_299_FLAG_ID = 'TEAME-299-skill-213-tutorial';

/**
 * The flag's three arms. `control` gets the baseline page; both treated arms get the rebuilt
 * skill 213, differing only in whether the tutorial runs.
 */
export const TEAME_299_CONTROL = 'control';
export const TEAME_299_NO_TUTORIAL = 'no-tutorial';
export const TEAME_299_TUTORIAL = 'tutorial';

export type Teame299TreatedVariant = typeof TEAME_299_NO_TUTORIAL | typeof TEAME_299_TUTORIAL;

/** True for the arms that render the experiment. Control and unassigned fall through to baseline. */
export const isTeame299Treated = (variant: string): variant is Teame299TreatedVariant =>
  variant === TEAME_299_NO_TUTORIAL || variant === TEAME_299_TUTORIAL;

export const TEAME_299_DATA_PERSISTENCE_VARIANT = 'default';
export const CHALLENGE_PASSING_SCORE = 8;
export const TEAME_299_SIDEBAR_MIN_WIDTH_PX = 320;
export const TEAME_299_SIDEBAR_MAX_WIDTH_PX = 400;
export const TEAME_299_SIDEBAR_WIDTH_PERCENT = 28;
export const TEAME_299_MAIN_VIEWPORT_MIN_WIDTH_PX = 720;
export const TEAME_299_MAIN_VIEWPORT_MIN_HEIGHT_PX = 540;

export interface Skill213LoggingData {
  firstAccessTimestamp: number | null;
  minutesToPass: number | null;
}

export const DEFAULT_SKILL_213_LOGGING_DATA: Skill213LoggingData = {
  firstAccessTimestamp: null,
  minutesToPass: null,
};
